// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wsrT","type":"styles_type__1WTsK","choices":"styles_choices__1HVhF"};